var _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _rect, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 79,
    viewBox: "0 0 192 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6792 2.25C44.8609 2.25 44.0781 2.58424 43.5123 3.17529L2.34204 46.1753C0.515328 48.0832 1.86758 51.25 4.50896 51.25H68.8252V49.25H4.50896C3.6285 49.25 3.17775 48.1944 3.78665 47.5584L44.9569 4.55843C45.1455 4.36142 45.4064 4.25 45.6792 4.25H146.958C147.235 4.25 147.499 4.36461 147.688 4.56658L187.943 47.5666C188.541 48.2054 188.088 49.25 187.213 49.25H95.8252V51.25H187.213C189.839 51.25 191.197 48.1163 189.403 46.1997L149.148 3.19973C148.581 2.59383 147.788 2.25 146.958 2.25H45.6792Z",
    fill: "#555760"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.325,
    cy: 31.75,
    rx: 2.5,
    ry: 1.5,
    fill: "#ED7238"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.325,
    cy: 40.75,
    rx: 2.5,
    ry: 1.5,
    fill: "#ED7238",
    fillOpacity: 0.77
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.325,
    cy: 22.75,
    rx: 2.5,
    ry: 1.5,
    fill: "#ED7238",
    fillOpacity: 0.77
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.325,
    cy: 23.25,
    rx: 2.5,
    ry: 1,
    fill: "#ED7238",
    fillOpacity: 0.77
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.3252,
    cy: 23.25,
    rx: 2.5,
    ry: 1,
    fill: "#ED7238",
    fillOpacity: 0.77
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.3252,
    cy: 31.25,
    rx: 2.5,
    ry: 1,
    fill: "#ED7238",
    fillOpacity: 0.77
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.3252,
    cy: 40.25,
    rx: 2.5,
    ry: 1,
    fill: "#ED7238",
    fillOpacity: 0.77
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.325,
    cy: 31.25,
    rx: 2.5,
    ry: 1,
    fill: "#ED7238",
    fillOpacity: 0.77
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.325,
    cy: 40.25,
    rx: 2.5,
    ry: 1,
    fill: "#ED7238",
    fillOpacity: 0.77
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.325,
    cy: 30.75,
    rx: 1.5,
    ry: 0.5,
    fill: "#ED7238",
    fillOpacity: 0.66
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.325,
    cy: 39.75,
    rx: 1.5,
    ry: 0.5,
    fill: "#ED7238",
    fillOpacity: 0.66
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.325,
    cy: 23.75,
    rx: 1.5,
    ry: 0.5,
    fill: "#ED7238",
    fillOpacity: 0.66
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 138.825,
    cy: 30.75,
    rx: 1,
    ry: 0.5,
    fill: "#ED7238",
    fillOpacity: 0.66
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.825,
    cy: 24.75,
    rx: 1,
    ry: 0.5,
    fill: "#ED7238",
    fillOpacity: 0.66
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.825,
    cy: 37.75,
    rx: 1,
    ry: 0.5,
    fill: "#ED7238",
    fillOpacity: 0.66
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69.8252,
    y: 24.25,
    width: 25,
    height: 53,
    rx: 3,
    fill: "#555760",
    fillOpacity: 0.14,
    stroke: "#555760",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3252 57.25L79.3252 24.75L94.3252 25.25V57.25Z",
    fill: "#555760",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74.8252,
    y: 23.25,
    width: 15,
    height: 4,
    rx: 2,
    fill: "#555760"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArPhone);
export default __webpack_public_path__ + "static/media/AR_Phone.6927c4de126fc4b42cc06e1f84e589df.svg";
export { ForwardRef as ReactComponent };